import HorizontalToolbarToggler from './HorizontalToolbarToggler';

export default HorizontalToolbarToggler;